import React from "react";
import { Descriptions } from "antd";
import "./ListSum.less";

const ListSum = ({ sumValues }) => {
   return (
      <ul className="list-sums">
         {Object.entries(sumValues).map(([title, value]) => (
            <Descriptions key={title} bordered size="middle" className="gx-mr-1 gx-mb-2">
               <Descriptions.Item label={title} className="gx-text-primary">
                  {value}
               </Descriptions.Item>
            </Descriptions>
         ))}
      </ul>
   );
};

export default ListSum;
